// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。echarts
import echarts from 'echarts/lib/echarts'
 
/** 引入柱状图and折线图图表，图表后缀都为 Chart  */

import 'echarts/lib/chart/tree'
 
 
// 导出
export default echarts;